<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
:root {
  --block-orange: #F99539;
  --background-gray: #F0F0F0;
  --form-blue: #015DC9;
  --button-green: #9ABD0E;
}

#app {
  font-family: system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 1%;
  display: flex;
  height: 100vh;
  width: 100%;
}
* {
  box-sizing: border-box;
}
</style>
